import { render, staticRenderFns } from "./MediaWatcher.vue?vue&type=template&id=01a8b9b0&scoped=true&"
import script from "./MediaWatcher.vue?vue&type=script&lang=js&"
export * from "./MediaWatcher.vue?vue&type=script&lang=js&"
import style0 from "./MediaWatcher.vue?vue&type=style&index=0&id=01a8b9b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8b9b0",
  null
  
)

export default component.exports